(function () {
  var root = document.querySelector('[data-nw-shell]');
  if (!root || root.__nwInit) return;
  root.__nwInit = true;

  var KEY = 'nw_seashell_v1';
  var delay = parseInt(root.getAttribute('data-delay'), 10) || 6000;
  var code = root.getAttribute('data-code') || '';
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var showInEditor = root.getAttribute('data-show-in-editor') === 'true';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function suppressed() {
    var s = read();
    if (s.claimed) return true;
    return !!(s.dismissed && Date.now() - s.dismissed < 3 * 24 * 60 * 60 * 1000);
  }
  if (inEditor && !showInEditor) return;
  if (!inEditor && suppressed()) return;

  var intro = root.querySelector('[data-nw-intro]');
  var stage = root.querySelector('[data-nw-tap]');
  var dots = root.querySelectorAll('.nw-shell__dots span');
  var live = root.querySelector('[data-nw-live]');
  var panel = root.querySelector('[data-nw-panel]');
  var success = root.querySelector('[data-nw-success]');
  var form = root.querySelector('form');
  var email = root.querySelector('#NWShellEmail');
  var submitBtn = root.querySelector('[data-nw-submit]');
  var errorEl = root.querySelector('[data-nw-error]');
  var copyBtn = root.querySelector('[data-nw-copy]');

  var LID = [0.86, 0.6, 0.05];
  var taps = 0;
  var sending = false;

  function dismiss() {
    var s = read();
    if (!s.claimed) write({ dismissed: Date.now() });
    if (root.open) root.close();
  }

  stage.addEventListener('click', function () {
    if (taps >= 3) return;
    taps++;
    stage.style.setProperty('--lid', LID[taps - 1]);
    if (!reduced) {
      stage.classList.remove('is-shaking');
      void stage.offsetWidth;
      stage.classList.add('is-shaking');
    }
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i < taps);
    live.textContent = taps < 3 ? 'Tap ' + taps + ' of 3. Keep going.' : 'The shell is open.';
    if (taps === 3) {
      stage.classList.add('is-open');
      stage.setAttribute('aria-disabled', 'true');
      setTimeout(showForm, reduced ? 0 : 900);
    }
  });

  function showForm() {
    intro.hidden = true;
    root.setAttribute('aria-labelledby', 'nw-shell-title-after');
    panel.hidden = false;
    try { email.focus({ preventScroll: true }); } catch (e) {}
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    sending = true;
    var original = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Claiming...';
    errorEl.hidden = true;

    fetch(form.getAttribute('action'), {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      var ok = res.ok && res.url.indexOf('/challenge') === -1 && res.url.indexOf('customer_posted=true') !== -1;
      if (!ok) throw new Error('signup failed');
      write({ claimed: Date.now() });
      if (code) {
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }
      panel.hidden = true;
      root.setAttribute('aria-labelledby', 'nw-shell-title-success');
      success.hidden = false;
    }).catch(function () {
      errorEl.textContent = 'Something went wrong. Please check your email and try again.';
      errorEl.hidden = false;
      submitBtn.disabled = false;
      submitBtn.textContent = original;
      sending = false;
    });
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      function done() { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000); }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else { done(); }
    });
  }

  var dismissers = root.querySelectorAll('[data-nw-dismiss]');
  for (var d = 0; d < dismissers.length; d++) dismissers[d].addEventListener('click', dismiss);
  root.addEventListener('cancel', function () { var s = read(); if (!s.claimed) write({ dismissed: Date.now() }); });
  root.addEventListener('click', function (e) { if (e.target === root) dismiss(); });

  function tryShow() {
    if (root.open) return;
    var typing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
    var busy = document.querySelector('dialog[open], cart-drawer.active, details-modal details[open], menu-drawer details[open]');
    if (typing || (busy && busy !== root)) { setTimeout(tryShow, 2500); return; }
    try { root.showModal(); } catch (err) {}
  }
  function start() { setTimeout(tryShow, delay); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();